import { maxRatingNPS } from "./interface/RatingNPS";
import { DivStyled, Text, ViewNumberNPS, TextNPS } from './Rating';


export default function AnswerNPS({ title, data }: any ) {

    return (
        
        <DivStyled>
            <Text margin={`15px`}> {title} </Text>
            {maxRatingNPS.map((item, key) =>
            (
                <>
                    <ViewNumberNPS color={item.value <= data ? item.color : 'rgba(0, 0, 0, 0.12)'}>
                        <TextNPS color={'#e3e3e3'}> {item.value}</TextNPS>
                    </ViewNumberNPS>
                </>
            ))}
        </DivStyled>
    )
}


